import useFormatters from "./useFormatters";

const usePriceNotFoundData = formik => {
  const {
    ItemNoFormatter,
    materialDescriptionFormatter,
    materialCodeFormatter,
    pricePerUnitFormatter,
    pricePerUnitHeaderFormatter
  } = useFormatters(formik);

  const columnsList: TableColumn[] = [
    {
      id: "itemNo",
      label: "Item No.",
      style: { width: 14, minWidth: 14, padding: 8, fontSize: "14px" },
      formatter: ItemNoFormatter,
      align: "center"
    },
    {
      id: "materialCode",
      label: "Material Code",
      style: { minWidth: 152, padding: 8 },
      formatter: materialCodeFormatter,
      align: "left"
    },
    {
      id: "materialDescription",
      label: "Material Description",
      style: { minWidth: 300, padding: 8 },
      align: "left",
      formatter: materialDescriptionFormatter
    },
    {
      id: "pricePerUnit",
      label: "ราคาต่อหน่วย (THB)",
      style: { minWidth: 64, padding: 8 },
      align: "left",
      formatter: pricePerUnitFormatter,
      headerFormatter: pricePerUnitHeaderFormatter
    }
  ];
  return {
    columnsList
  };
};
export default usePriceNotFoundData;
